import { render, staticRenderFns } from "./FieldTextAreaInput.vue?vue&type=template&id=28ff5f42&scoped=true&"
import script from "./FieldTextAreaInput.vue?vue&type=script&lang=js&"
export * from "./FieldTextAreaInput.vue?vue&type=script&lang=js&"
import style0 from "./FieldTextAreaInput.vue?vue&type=style&index=0&id=28ff5f42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ff5f42",
  null
  
)

export default component.exports